import {
  Create,
  ListButton,
  number,
  NumberInput,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const AccessLevelCreate = () => (
  <Create actions={<CreateActions />} redirect="list" title="Access Level">
    <SimpleForm toolbar={<CreateToolbar />}>
      <TextInput
        source="title"
        helperText="example: Gold"
        validate={required()}
      />
      <TextInput
        source="name"
        helperText="example: power-gold"
        validate={required()}
      />
      <NumberInput source="level" helperText="example: 1" validate={number()} />
    </SimpleForm>
  </Create>
);
